import { BaseRouteService } from 'core/services';

class InsuranceCoverageStatusOverviewRouteService extends BaseRouteService {
    constructor() {
        super('insurance-coverage-status-overview');
    }

    download() {
        return super.find(this.base + '/download');    
    }

    getEmailPrefillData(id) {
        return super.get(this.base + '/get-email-prefill-data/{id}', id);
    }

    getNikoEmailPrefillData(id) {
        return super.get(this.base + '/get-niko-email-prefill-data/{id}', id);
    }

    sendEmail(resource) {
        return super.create(`${this.base}/send-email`, resource);
    }

    sendEmailManually(resource){
        return super.create(`${this.base}/send-manually/${resource.facilityOrderId}/confirm`, resource);
    }
}

export default InsuranceCoverageStatusOverviewRouteService;
